import { chain, each, get } from 'lodash'
import { CashRegisterTransactionSummaryXlsxHeaders } from '@/utils/constants/table-headers'

export default cashRegisterTransactionSummaries => {
  // Excel ダウンロードは既存「終了時点レジ内金額」を残してデグレを防ぎつつ、
  // 新たに「翌日繰越金額」列を追加する。UI と独立した XLSX 用ヘッダーを使用。
  const buildXlsxData = () => {
    return chain(cashRegisterTransactionSummaries.value)
      .map(o => {
        const data = {}

        each(CashRegisterTransactionSummaryXlsxHeaders, h => {
          const val = get(o, h.value)
          data[h.text] = Number.isNaN(Number(val)) ? val : Number(val)
        })

        return data
      })
      .value()
  }

  return {
    buildXlsxData,
  }
}
